import type {ComponentProps} from '@enonic/react-components'
import type {ResponsiveImageData} from '../primitives'
import type {CtaButton} from '../../utils/ctaUtils'
import * as React from 'react'
import {Hero} from '../primitives'

export interface EducationLandingData extends Record<string, unknown> {
    title: string
    lead: string
    heroImage?: ResponsiveImageData
    ctaPrimary?: CtaButton
    ctaSecondary?: CtaButton
}

export const EducationLanding = (props: ComponentProps) => {
    const data = props.data as EducationLandingData
    const {title, lead, heroImage, ctaPrimary, ctaSecondary} = data

    return (
        <Hero
            title={title}
            lead={lead}
            image={heroImage}
            ctaPrimary={ctaPrimary}
            ctaSecondary={ctaSecondary}
        />
    )
}
